import { useEffect, useState } from "react";
import axios from 'axios';

export const useAuth = () => {
    const [authenticated, setAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (!token) {
            console.log("Token not found");
            setAuthenticated(false);
            setLoading(false);
            return;
        }

        axios.get('/api/check_token', {
            headers: { Authorization: 'Bearer ' + token }
        }).then(response => {
            if (response.status === 200) {
                setAuthenticated(true);

                // Refresh the token
                if (response.data.access_token) {
                    localStorage.setItem('token', response.data.access_token);
                }
            }
            setLoading(false);
        }).catch((error) => {
            console.log("[DEBUG] ", error);
            console.log("Token is invalid");
            setAuthenticated(false);
            localStorage.removeItem('token');
            setLoading(false);
        });
    }, []);

    // const login = (user) => {
    //     setUser(user);
    //     setItem("user", JSON.stringify(user));
    // };

    const logout = () => {
        axios.post('/api/logout', {}, { withCredentials: true })
            .then(() => {
                setAuthenticated(false);
                localStorage.removeItem('token');
                window.location.href = '/';
            })
            .catch(() => {
                setAuthenticated(false);
                localStorage.removeItem('token');
                window.location.href = '/';
            });
    }

    const isLogged = () => {
        return authenticated;
    }

    const getToken = () => {
        return localStorage.getItem('token');
    }

    return {isLogged, loading, getToken, logout};
}